import React from 'react';
import { Card, CardImg, CardImgOverlay, CardTitle, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';

function RenderMenuItem({dish}) {
  return (
    <Card>
      <Link to={`/menu/${dish.id}`} >
        <CardImg style={{minHeight: 330, maxHeight: 550}} src={dish.image} alt={dish.name} />
        <CardImgOverlay>
          <CardTitle>{dish.name}</CardTitle>
        </CardImgOverlay>
      </Link>
    </Card>
  );
}

function Menu(props) {
  const menu = props.dishes.map((dish) => {
      return (
        <div key={dish.id} className="col-12 col-md-5 m-1">
          <RenderMenuItem dish={dish} />
        </div>
      );
  });

  // if(props.dishes.isLoading) {
  //   return (
  //       <div className='conatainer'>
  //           <div className='row'>
  //               <Loading />
  //           </div>
  //       </div>
  //   );
  // }
  // else if(props.dishes.errMess) {
  //   return (
  //       <div className='conatainer'>
  //           <div className='row'>
  //               <h4>{props.dishes.errMess}</h4>
  //           </div>
  //       </div>
  //   );
  // }
  // else {
    return (
      <div className="container">
        <div className='row'>
          <Breadcrumb>
            <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
            <BreadcrumbItem active>Menu</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className='col-12'>
          <h3>Menu</h3>
          <hr />
        </div>
        <div className="row">
          {menu}
        </div>
      </div>
    );
  // }
}

export default Menu;